import FullWrapper from '../../layouts-components__common-cases/full-wrapper';
import './style.sass';
import Image from 'next/image';

type ChallengeType = {
    title: string;
    icon: string;
    width: number;
    height: number;
};
type ChallengesPropsType = {
    list: ChallengeType[];
};
const Challenges = ({ list }: ChallengesPropsType) => {
    return (
        <div className="rgs-challenges">
            <FullWrapper isMargin={false}>
                <div className="rgs-challengesWrapper">
                    <div className="rgs-challengesTitle">Вызовы проекта</div>
                    <div className="rgs-challengesInner">
                        <div className="rgs-challengesLeft">
                            <div className="rgs-challengesDescription">
                                Одним из&nbsp;главных вызовов стала интеграция
                                с&nbsp;14&nbsp;различными внутренними подсистемами
                                &laquo;Росгосстраха&raquo;, которые содержали данные
                                о&nbsp;клиентах, страховых продуктах и&nbsp;договорах. В&nbsp;данном
                                случае количество интеграций значительно увеличило сложность
                                разработки. Настройка взаимодействия с&nbsp;подсистем потребовала
                                тщательной проработки и&nbsp;согласования архитектуры, которые
                                обеспечила команда &laquo;Вебпрактик&raquo;.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="rgs-challengesResults">
                <FullWrapper isMargin={false}>
                    <div className="rgs-challengesResultsContent">
                        <div className="rgs-challengesResultsTitle">
                            14&nbsp;интеграций с&nbsp;ЛК
                        </div>

                        <Image
                            src="/images/pic/rgs/c1.png"
                            alt="marker"
                            width={1199}
                            height={571}
                            className="rgs-challengesResultsImg"
                        />
                    </div>
                </FullWrapper>
            </div>
            <FullWrapper isMargin={false}>
                <div className="rgs-challengesWrapper">
                    <div className="rgs-challengesTitle">Результаты</div>
                    <div className="rgs-challengesInner">
                        <div className="rgs-challengesLeft">
                            <div className="rgs-challengesDescription">
                                Удобный и&nbsp;функциональный личный кабинет продавца стал
                                эффективным инструментом для сотрудников &laquo;Росгосстраха&raquo;,
                                что привело к&nbsp;повышению скорости оформления и&nbsp;обслуживания
                                договоров, улучшению качества предоставляемых услуг и&nbsp;повышению
                                конкурентоспособности компании на&nbsp;рынке страховых услуг.
                            </div>
                            <div className="rgs-challengesDescription">
                                Микросервисная архитектура стала ключевым решением в&nbsp;рамках
                                проекта. Такой подход позволил разделить функциональность
                                на&nbsp;отдельные, независимые компоненты, что обеспечило гибкость
                                при внедрении новых бизнес-функций и&nbsp;ускорило процесс
                                разработки.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
            <div className="rgs-challengesDignity">
                <FullWrapper isMargin={false}>
                    <div className="rgs-challengesDignityContent">
                        {list &&
                            list.map(({ title, icon, width, height }) => (
                                <div className="rgs-challengesDignityItem" key={title}>
                                    <div
                                        className="rgs-challengesDignityText"
                                        dangerouslySetInnerHTML={{ __html: title }}
                                    ></div>
                                    <Image
                                        src={icon}
                                        alt="marker"
                                        width={width}
                                        height={height}
                                        className="rgs-challengesDignityImg"
                                    />
                                </div>
                            ))}
                    </div>
                </FullWrapper>
            </div>
            <FullWrapper isMargin={false}>
                <div className="rgs-challengesWrapper">
                    <div className="rgs-challengesInner">
                        <div className="rgs-challengesLeft">
                            <div className="rgs-challengesDescription">
                                Адаптивная верстка и&nbsp;оптимизация под мобильные устройства
                                позволяют сотрудникам комфортно взаимодействовать с&nbsp;интерфейсом
                                и&nbsp;быстрее реагировать на&nbsp;запросы клиентов. Интуитивно
                                понятный дизайн и&nbsp;продуманное расположение элементов дают
                                возможность свести к&nbsp;минимуму количество действий для
                                выполнения основных операций, что сокращает время обслуживания
                                и&nbsp;улучшает клиентский сервис.
                            </div>
                            <div className="rgs-challengesDescription">
                                И&nbsp;уже в&nbsp;первом месяце после введения системы
                                в&nbsp;эксплуатацию были выполнены KPI, благодаря слаженной работы
                                команд подрядчика и&nbsp;заказчика, от&nbsp;аналитиков
                                до&nbsp;тестировщиков.
                            </div>
                            <div className="rgs-challengesDescription">
                                Функционал формирования котировки (предпродажа), оформления
                                и&nbsp;оплаты договора ОСАГО уже запущен и&nbsp;успешно используется
                                сотрудниками РГС. Функционал для работы с&nbsp;полисами КАСКО
                                проходит последний этап тестирования перед вводом
                                в&nbsp;эксплуатацию.
                            </div>
                            <div className="rgs-challengesDescription">
                                Промышленная эксплуатация процессов КАСКО и&nbsp;ОСАГО запланирована
                                на&nbsp;1-й квартал 2025&nbsp;года.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Challenges;
